const variants = {
  diamond: {
    root: ' transform rotate-45',
    item: ' transform -rotate-45',
  },
  pill: {
    root: ' rounded-full',
    item: '',
  },
};

export const themes = {
  default: ({ variant }) => ({
    thRoot: `${variant ? variants[variant].root : ''} bg-saffron border-saffron text-black relative isolate bg-saffron border-saffron size-50 text-black border-1 flex-none inline-flex items-center justify-center leading-0 overflow-hidden`,
    thIcon: `absolute flex items-center justify-center inset-0${
      variant ? variants[variant].item : ''
    }`,
    thIconSize: '65%',
    thLabel: `absolute flex items-center justify-center leading-tight overflow-hidden inset-0 text-[1em] text-center ${
      variant ? variants[variant].item : ''
    }`,
  }),
};
